export default () => {
  const data = {
    event_name: 'click',
    button_name: 'right_schedule_visit',
    page_section: 'card_section',
    name_of_the_page_viewed: 'development_details_personal',
  };
  return data;
};
